import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "scale(0.75)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M28.5799 3.44248C27.9129 2.75797 26.9258 2.50295 26.0055 2.77139L4.54334 9.01254C3.57228 9.28231 2.884 10.0568 2.69859 11.0406C2.50918 12.0418 3.17078 13.3129 4.03514 13.8444L10.7459 17.9689C11.4342 18.3917 12.3225 18.2857 12.8921 17.7112L20.5766 9.97891C20.9634 9.57625 21.6037 9.57625 21.9905 9.97891C22.3773 10.3681 22.3773 10.999 21.9905 11.4016L14.2927 19.1353C13.7218 19.7084 13.6151 20.6009 14.0352 21.2935L18.1356 28.0715C18.6158 28.8768 19.4428 29.3332 20.3498 29.3332C20.4565 29.3332 20.5766 29.3332 20.6833 29.3197C21.7237 29.1855 22.5507 28.4742 22.8575 27.4675L29.2201 6.03289C29.5002 5.12021 29.2468 4.12699 28.5799 3.44248Z",
			fill: "currentColor"
		})
	})
});
export default SvgSendFill;
